import { useCallback } from 'react';
import { renderToString } from 'react-dom/server';
import { faBullhorn, faReceipt, faTicket, faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LinkedResourceText } from 'components/tasks/LinkedResourceText';
import {
    LinkableCampaign,
    LinkableContact,
    LinkableTicket,
    LinkableTransaction,
    TaskLinkable,
} from 'types/domain';

interface GenerateTaggedResourceHtmlOptions {
    type: TaskLinkable['linkable_type'];
    resource: LinkableCampaign | LinkableContact | LinkableTicket | LinkableTransaction;
}

const generateTaggedResourceHtml = ({ resource, type }: GenerateTaggedResourceHtmlOptions) => {
    return renderToString(<TaggedResourceContainer resource={resource} type={type} />);
};

const TaggedResourceContainer = ({ type, resource }: GenerateTaggedResourceHtmlOptions) => {
    const Icon = useCallback(() => {
        switch (type) {
            case 'contact':
                return <FontAwesomeIcon icon={faUser} size="sm" />;
            case 'transaction':
                return <FontAwesomeIcon icon={faReceipt} size="sm" />;
            case 'ticket':
                return <FontAwesomeIcon icon={faTicket} size="sm" />;
            case 'campaign':
                return <FontAwesomeIcon icon={faBullhorn} size="sm" />;
        }
    }, [type]);

    return (
        <>
            <span
                className={TINY_LINKED_RESOURCE_TAG_CLASSES}
                data-gb-task-link
                data-gb-link-type={type}
                data-gb-link-id={resource.id}
            >
                <Icon />
                <LinkedResourceText type={type} linkable={resource} />
            </span>{' '}
        </>
    );
};

const TINY_LINKED_RESOURCE_TAG_CLASSES =
    'inline-flex items-center gap-2 rounded-md bg-blue-50 px-1.5 py-0.5 text-sm font-medium leading-5 text-blue-500';

export { generateTaggedResourceHtml, TINY_LINKED_RESOURCE_TAG_CLASSES };
export type { GenerateTaggedResourceHtmlOptions };
